import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
    filtersContainer: {
        flex: 1,
        marginTop: 20,
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 0px',
        maxWidth: 700
    },
    filtersInputs: {
        flex: 1,
        display: 'flex',
        '& MuiFormControl-root': {
            flex: 1,
            maxWidth: 400,
        },
    },
    filterSeparation: {
        marginRight: 18,
        flex: 1,
        maxWidth: '390px',
        background: 'white',
    },
    idFilter: {
        minWidth: 200
    }
}));

export interface AAListFilters {
    extensionFilter: string;
    didNumberFilter: string;
    idFilter       : string
}